const BigWoman = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="106"
    height="138"
    viewBox="0 0 106 138"
  >
    <g fill="none">
      <path
        fill="#D7854C"
        d="M55.552 122.31l4.18 7.892s2.329 2.841 5.676 2.246l14.374 5.03s2.221-.377 1.421-2.406c0 0 1.485.55 1.082-1.85 0 0 3.309-1.881.57-3.25l-.57-.903s3.641-1.408.64-3.06l-18.131-2.457-5.274-8.026-3.968 6.784"
      />
      <path
        fill="#D1445C"
        d="M23.264 99.686L21.024 103.123 52.717 119.821 80.211 101.184 73.862 97.875 23.264 99.686"
      />
      <path
        fill="#990C16"
        d="M77.766 101.862l-1.222.34-23.04 15.02-12.16-6.643 4.051 2.624.224-.09 7.648 4.327.25-.218 22.79-14.521c.475-.314.971-.594 1.485-.839m-53.312-1.766c.512.154 1.014.338 1.504.55l14.08 9.095c6.157 2.822 10.88 3.379 13.702 3.379.947.02 1.893-.059 2.823-.237 4.109-1.645 9.862-11.52 9.862-11.52l2.125-.3c-5.05.473-10.029.64-14.72.64-4.691 0-9.293-.193-13.325-.461-4.019-.141-8.205-.397-12.467-.807h-.64l.3-.045c-1.055-.102-2.111-.217-3.2-.339m53.044-.326h-.134.108l2.496 1.28-2.496-1.28"
      />
      <path
        fill="#F1AF6D"
        d="M41.894 27.776S38.33 43.52 50.797 44.762c0 0 9.862 1.92 11.917-8.32l1.094-8.282-6.438-4.48-3.424-6.029-9.312 2.605-2.74 7.52"
      />
      <path
        fill="#454560"
        d="M50.17 16.544S39.814 17.76 39.974 29.267c1.363-.182 2.71-.462 4.032-.838 1.172-.307 2.068-1.389 3.303-2.157.845-.525 3.84-1.03 4.589-1.85 1.222-1.28 3.2-2.88 3.622-5.76 0-.096-.288 0-.589.052-.3.05-.601.14-.576.05.141-.486.256-.934.359-1.343 2.227-8.96-4.544-.851-4.544-.851"
      />
      <path
        fill="#D7854C"
        d="M45.594 113.114L56.96 119.552 52.166 127.085 40.294 128.499 37.92 121.741 39.155 115.712 45.594 113.114"
      />
      <path
        fill="#D1445C"
        d="M45.594 113.344l-19.636-12.698c-2.543-1.05-5.29-1.518-8.038-1.37-4.48.282-14.272 1.383-15.86 11.694 0 0-.863 5.856 3.028 7.25 0 0 10.957 9.198 26.522 9.198l8.96 1.53s-5.044-8.5 5.05-15.604"
      />
      <path
        fill="#D7854C"
        d="M69.427 80.102l12.327 18.63s2.073-1.145 6.457-.78l-6.291-15.93-1.325-10.137-8.793-.845-2.375 9.062z"
      />
      <path
        fill="#8F90A0"
        d="M97.92 96.333l5.613-8.519c.218-.323.29-.722.2-1.102-.09-.38-.334-.704-.674-.894l-6.24-3.322c-.58-.293-1.286-.106-1.645.435l-9.414 14.15c-.228.337-.297.757-.19 1.15.107.392.38.718.747.892l6.931 3.034c.6.248 1.29.009 1.606-.557l3.015-5.197.051-.07z"
      />
      <path
        fill="#454560"
        d="M99.443 96.98l5.76-8.756c.18-.266.24-.594.167-.906-.073-.312-.272-.58-.55-.739l-6.657-3.539c-.478-.25-1.068-.091-1.357.365l-9.676 14.56c-.19.276-.249.622-.162.946.088.324.313.593.616.737l7.373 3.2c.49.21 1.061.014 1.318-.454l3.123-5.383.045-.032z"
      />
      <path
        fill="#922F45"
        d="M10.387 100.787l-3.968 5.12c-.484.438-1.088.72-1.734.813-.137.003-.272-.033-.39-.102.386.355.89.555 1.414.563 1.126 0 2.771-.967 4.435-5.402l.243-1.005"
      />
      <path
        fill="#B2B2BF"
        d="M15.488 99.5l-1.408.084-.18.166c.551-.102 1.089-.185 1.594-.25"
      />
      <path
        fill="#922F45"
        d="M16.14 99.462l-.64.039c-.505.064-1.042.147-1.593.25l-.973.895-2.188 5.959c-.088.143-.228.247-.39.288.155.047.317.071.48.07.637-.041 1.238-.315 1.689-.768l1.401-5.12 2.228-1.606"
      />
      <path
        fill="#F1AF6D"
        d="M86.24 93.165l-4.32-11.143c.07-3.77-1.504-8.838-1.504-8.838l1.094-.34-.07-1.03c.826-13.766-4.109-15.686-4.109-15.686-5.683-4.723-13.561-6.707-13.561-6.707l-6.708-.89v-5.12l-9.6-.07-.416 4.25-7.872 2.054s-9.6 3.078-14.176 7.603c0 0-2.47 4.723-5.068 19.2l-.141 7.258-7.891 10.438-.756.269s.55-5.338-2.4-5.203c0 0-1.638 0-.819 1.779 1.008 1.029 1.42 2.501 1.095 3.904l-.75.64-1.849.064s-1.85-2.189-.14-3.84c0 0 1.28-.34.345-1.37 0 0-2.125-.48-3.2 2.74 0 0-1.1 2.259 1.85 5.068L.41 104.493s.07 1.85 2.259.48l4.864-4.384-3.565 5.414s.07 1.709 2.47-.07l3.968-5.12-1.28 5.337s1.024 1.37 1.645.48l2.189-5.958 4.518-4.18 7.744-5.542-2.604 8.628 54.598-1.07-.64-7.558 6.234 9.652s4.864 6.099 11.302 3.155l1.709-.205 4.934-5.478s2.055-1.581.755-2.56c0 0-1.85.339-5.76 4.243l-1.235.55 4.589-4.384s1.44-2.56-2.598.205l-3.84 3.974 4.313-5.619s0-1.92-2.803 1.03l-3.155 3.425s2.47-3.29 1.92-4.384c0 0-1.85.32-3.629 3.808 0 0-4.109-1.479-6.438-.314l3.392-4.883M63.565 129.478L48.755 133.606 40.8 128.41 53.491 117.222 62.528 116.262 66.816 123.347 63.565 129.478"
      />
      <path
        fill="#D7854C"
        d="M71.98 72.32s-2.374 6.848-4.018 8.493c0 0 8.582 10.285 13.696 17.92 1.034-.669 2.178-1.152 3.379-1.427l1.83-2.464-4.947-12.839s-.166-1.145-.307-3.84l-5.523-7.398-4.11 1.555zM23.814 72.525s5.204 3.104 3.015 11.136c-3.14 5.076-7.235 9.495-12.058 13.011 0 0-.8 2.675-1.619 3.77l4.358-3.962 9.728-6.79 5.888-13.562-2.188-6.163-7.124 2.56z"
      />
      <path
        fill="#454560"
        d="M37.888 49.568s-1.152 15.834 14.278 16.378c0 0 12.75 2.31 15.488-15.316l10.72 5.639s5.568 3.744 4.75 16.8l-1.69.454c-1.904.518-3.881.717-5.85.589l-1.958-.128s-.25 6.643-3.84 8.013c0 0 8.825 7.27 7.724 17.785 0 0-26.419 3.604-54.547.135l.077-1.997s3.475-11.232 6.669-15.251l.915-2.01s-2.47-4.653-.915-9.037c-3.186 1.422-6.813 1.486-10.048.18 0 0 1.005-9.952 4.384-15.066 0 0 7.18-4.602 13.85-7.155"
      />
      <path
        fill="#F1AF6D"
        d="M48.755 133.606l-7.68.736c-1.217 1.123-2.95 1.491-4.518.96l-17.127-.262s-2.195-.96-.55-2.33c0 0-1.78 0-.41-1.779 0 0-2.739-2.464.685-2.739l.96-.55s-3.29-2.19.544-2.599l20.07 3.424 8.698-4.793-.64 9.945"
      />
      <path
        fill="#D7854C"
        d="M101.28 95.597c.672.774-.352 1.92-4.973 5.965-.185.16-2.982 1.376-8.793-.308l4.934 2.906 3.34-.64 5.793-6.17s1.037-1.875-.301-1.76"
      />
      <path
        fill="#464F5E"
        d="M47.36 27.968s1.018-2.266 4.774-2.451c.117.47.169.955.154 1.44-.109.224-3.34.454-4.928 1.011zM48 29.222s.109 1.863 2.362 1.959c1.19.159 2.315-.584 2.636-1.741-.622.789-1.606 1.202-2.604 1.094C48.53 30.432 48 29.222 48 29.222z"
      />
      <path
        fill="#D7854C"
        d="M55.635 19.712s1.754 3.328.762 8.704c-.231.868-.34 1.764-.327 2.662l1.024 3.028s0 2.035-2.17 1.574c0 0 .8 7.45 0 7.917 0 0-.575 1.28-.914 1.35 0 0 6.214 1.402 8.377-6.624l1.69-10.413-3.527-5.452-4.921-2.746"
      />
      <path
        fill="#D7854C"
        d="M47.82 35.456c.2.677.586 1.285 1.114 1.754 1.541 1.365 3.763 1.645 5.594.704.051-.128-.864 1.606-3.962 1.1-3.123-.876-2.777-3.73-2.745-3.558z"
      />
      <path
        fill="#F1AF6D"
        d="M41.773 29.114s-5.549-2.4-2.355 4.243c0 0-.43 2.477 1.817 2.06l2.349-1.67-1.811-4.633z"
      />
      <path
        fill="#D7854C"
        d="M47.917 43.782s.774 4.672 3.494 6.868c1.248 1.004 2.1 2.72 4.73 2.054 4.723-1.19 3.776-.89 7.04 1.58l2.669 2.945.972-2.08c.251-.575.465-1.165.64-1.767l.596-2.56s-3.642-2.144-11.072-2.278v-4.589s-3.584 1.837-9.07-.173zM41.395 29.85s-2.336-1.03-1.28 1.35l.18 1.325-.045.704.684.589.596-.154-.141-3.411.006-.403z"
      />
      <path
        fill="#454560"
        d="M57.965 16.544s6.7.55 6.598 12.058c0 0-.749.537-2.528-.173-.774-.307-1.37-1.389-2.182-2.157-.557-.525-2.56-1.03-3.034-1.85-.806-1.28-2.099-2.88-2.393-5.76 0-.096.192 0 .39.052.198.05.397.14.384.05-.096-.486-.173-.934-.243-1.343-1.472-8.96 3.008-.851 3.008-.851"
      />
      <path
        fill="#454560"
        d="M50.656 4.768s-6.707-1.37-7.942 4.518c0 0-2.19 5.344 2.195 8.493 0 0 4.723 3.994 9.651 1.389l4.045-2.349s4.518-4.793-1.37-9.312c0 0-1.094-2.739-6.579-2.739"
      />
      <path
        fill="#454560"
        d="M53.946.749S47.232-.64 46.003 5.267c0 0-2.195 5.344 2.189 8.493 0 0 4.384 3.84 9.318 1.235l4.378-2.195s4.525-4.794-1.37-9.312c0 0-1.094-2.74-6.572-2.74"
      />
      <path
        fill="#F4E3D9"
        d="M60.563 31.194c-.016-.615-.445-1.14-1.043-1.28-1.069-.308-2.163-.058-2.227.883-.064.94.313 1.28 1.92 1.197 1.606-.084 1.35-.8 1.35-.8z"
      />
      <path
        fill="#464F5E"
        d="M58.88 30.528s-.736.384-.544 1.069c.111.32.389.555.723.61.335.057.674-.075.883-.341.295-.596.16-.948-.147-1.204-.277-.157-.604-.205-.915-.134zM61.26 28.851s-.64-2.406-4.3-3.2c-.194.445-.325.915-.39 1.395.076.23 3.225.992 4.69 1.805z"
      />
      <path
        fill="#69697F"
        d="M46.08 8.525s-1.6 2.4-1.408 4.288c.192 1.888 2.49 4.083 2.49 4.083s-2.42-5.754-1.082-8.371zM49.069 7.514c.077.179.352-1.997 1.42-3.296.57-.736 1.342-1.29 2.221-1.594 0 0-1.817-.384-2.88.755-1.062 1.14-1.043 3.456-.761 4.135z"
      />
      <path
        fill="#454560"
        d="M46.38 17.088c-.48-.096-4.089 2.4-7.135-3.238 0 0 .96 7.859 7.539 5.548l-.403-2.31z"
      />
      <path
        fill="#69697F"
        d="M50.842 20.064c-.52 2.302-2.569 3.933-4.928 3.923 0 0-2.01.186-2.605 1.735 0 0-.09-1.46 2.65-2.83 1.936-.263 3.69-1.279 4.883-2.828z"
      />
      <path
        fill="#454560"
        d="M40.64 27.872s2.234 3.162 1.58 3.84c0 0 1.28-.525 0-4l-1.58.16z"
      />
      <path
        fill="#D7854C"
        d="M10.547 100.602l-4.723 4.934s-.986 1.318-1.485 1.094c0 0 .935.48 2.33-.89l3.878-5.138zM7.994 100.147L2.15 104.32s-.64 1.05-1.35.98c0 0 .96.594 2.349-.775l4.845-4.378z"
      />
      <path
        fill="#1B1934"
        d="M70.317 64.256s3.699 5.478 3.309 9.728l2.073.038c2.054.09 4.11-.126 6.1-.64l1.28-.32s3.603-17.76-14.957-22.278c0 0-1.92 13.146-13.287 15.27 0 .007 7.949 1.012 15.482-1.798zM47.853 72.109H55.431000000000004V73.81099999999999H47.853zM29.645 71.565l.473-1.024-1.92-7.789-1.1 7.488-4.02 2.234c.084-.052 4.064.64 6.567-.91zM70.157 87.77s.288 3.014-1.607 5.036v.077c.006.834-.2 1.656-.601 2.387l-.064.07h.352s-3.015 8.762-38.535 4.2l-6.438.134s20.685 2.97 39.68.96l12.602-4.928-5.39-7.95"
      />
      <path
        fill="#EF795C"
        d="M19.84 126.618l-.34-.154c-.346-.162-.497-.573-.338-.922l.083-.179c.16-.346.569-.497.915-.339l.346.154c.346.162.498.573.339.921l-.083.18c-.163.346-.574.498-.922.339"
      />
      <path
        fill="#D1445C"
        d="M45.594 113.344l-19.636-12.698c-2.543-1.05-5.29-1.518-8.038-1.37h-.294c-.775 5-1.754 10.042-4.122 14.554-1.332 2.468-2.94 4.776-4.794 6.88 4.48 2.727 12.679 6.688 22.9 6.688l8.96 1.53s-5.044-8.5 5.05-15.603"
      />
      <path
        fill="#454560"
        d="M49.222 80.749s-1.542.243-1.164 1.408l.134.64c-.244-.014-.477.104-.61.31-.132.205-.143.465-.03.682h1.677l.992-1.37-.999-1.67z"
      />
      <path
        fill="#D1445C"
        d="M76.282 102.7l-22.79 14.522s11.007.596 9.894 12.512l27.232-.736s4.633.141 6.81-4.928c0 0 8.69-11.097-1.018-18.764 0 0-11.444-8.359-20.128-2.605"
      />
      <path
        fill="#C1C1CC"
        d="M94.08 103.846c.81.437 1.591.923 2.342 1.453.186.141.359.288.532.435l-.135-.134c-.538-.501-1.138-.931-1.785-1.28l-.916-.474"
      />
      <path
        fill="#A3653D"
        d="M89.638 101.856c1.53.541 3.011 1.21 4.43 1.997h.012l-1.6-.839c-.41-.217-2.06-.89-2.502-1.043l-.365-.109"
      />
      <path
        fill="#C1C1CC"
        d="M98.688 122.112c-.38.682-.808 1.336-1.28 1.958-.26.611-.584 1.192-.966 1.735.917-1.117 1.668-2.36 2.227-3.693m2.189-9.6c.077.509.12 1.022.128 1.536.003-.447-.023-.894-.077-1.338l-.051-.198m-2.35-5.12c.368.444.702.915 1 1.408-.2-.47-.478-.902-.82-1.28l-.16-.16"
      />
      <path
        fill="#B68457"
        d="M63.187 125.286c0 .327.051.845.077 1.376l.173 2.407c.087-1.266.004-2.539-.25-3.783"
      />
      <path
        fill="#C1C1CC"
        d="M93.805 128.154c-.97.52-2.048.81-3.149.844h-.038l-8.237.224 8.787-.192c.938-.074 1.843-.377 2.637-.883"
      />
      <path
        fill="#A3653D"
        d="M82.381 129.222L81.389 129.248 82.381 129.229 82.381 129.222"
      />
      <path
        fill="#9E334A"
        d="M87.507 101.229s15.603 8.153 9.543 15.808l-8.538-1.46-25.344 9.44v.27c.253 1.243.337 2.516.25 3.782l.044.57 17.92-.391h.992l8.237-.224h.039c1.1-.035 2.178-.324 3.148-.845.084-.045.16-.096.237-.147.91-.613 1.724-1.354 2.42-2.202.382-.542.706-1.123.966-1.734.471-.622.9-1.277 1.28-1.958.064-.141.128-.288.185-.442 1.273-2.37 2-4.993 2.132-7.68-.008-.514-.051-1.027-.128-1.536-.346-1.277-.798-2.523-1.35-3.725-.298-.493-.632-.964-1-1.408l-1.586-1.613c-.173-.147-.346-.294-.532-.435-.75-.53-1.533-1.016-2.342-1.453-1.418-.787-2.9-1.455-4.429-1.996l-2.131-.64"
      />
      <path
        fill="#EBC2A5"
        d="M59.987 130.477L54.611 131.974 60.058 130.541 59.987 130.477"
      />
      <path
        fill="#D7854C"
        d="M63.405 129.523l-3.418.954.07.064 3.335-.877c.003-.047.003-.094 0-.14"
      />
      <path
        fill="#EBC2A5"
        d="M19.61 135.04l16.928.256-16.928-.256m20.85-.211c-.724.46-1.566.702-2.425.697-.502-.003-1.002-.076-1.485-.217.588.202 1.203.312 1.824.326.779.04 1.537-.253 2.087-.806"
      />
      <path
        fill="#E49A5C"
        d="M63.066 124.762l-2.368.23-5.76 2.88-5.92 1.709-.263 3.936.525-.141 5.325-1.402 5.376-1.497 3.417-.954c.004-.057.004-.115 0-.173l-.115-.563c.032-.294 0-1.241-.038-2.125l-.115-1.555c0-.115-.052-.23-.084-.345"
      />
      <path
        fill="#E49A5C"
        d="M49.024 129.58c-6.65 1.92-7.328 2.042-7.328 2.042-1.83 2.708-5.76 2.964-7.213 2.964h-.537c-2.176-.103-4.11-.141-5.805-.141-2.89-.047-5.778.103-8.647.448l.116.153 16.94.27c.483.14.983.214 1.485.217.859.005 1.7-.238 2.426-.698.161-.165.291-.358.384-.57 0 0 6.598-.64 7.193-.64h.09c.216-.02.43-.058.64-.115l.262-3.936"
      />
      <path
        fill="#D46554"
        d="M63.418 129.35c.003.058.003.116 0 .173.003.047.003.094 0 .141h.09l-.065-.288m-.294-4.595h-.058c.032.115.058.23.083.345v-.352"
      />
      <path
        fill="#C78551"
        d="M63.264 126.662c.038.884.07 1.83.038 2.125l.116.563v-.281l-.173-2.407"
      />
      <path
        fill="#BB5C4B"
        d="M63.437 129.069L63.437 129.35 63.501 129.638 63.456 129.069"
      />
      <path
        fill="#C1C1CC"
        d="M19.053 125.44L19.117 125.472 19.117 125.472 19.046 125.472"
      />
      <path
        fill="#B68457"
        d="M40.422 128.717c.077.153.122.23.122.23l-.122-.23m-10.681-1.357l10.803 1.574-8.96-1.53c-.64 0-1.28 0-1.869-.044m-8.845-1.395s0 .064-.032.096l.96.14c-.313-.076-.64-.153-.928-.236m-1.772-.512h.07-.07"
      />
      <path
        fill="#B55C4A"
        d="M19.2 125.485l1.062.486.64.083c0-.032 0-.064.032-.096-.582-.153-1.152-.32-1.702-.492"
      />
      <path
        fill="#9E334A"
        d="M14.912 120.506c-1.01.361-2.078.528-3.149.492-.857-.003-1.712-.067-2.56-.192-.3-.038-.48-.076-.48-.076l10.33 4.71h.14c.551.173 1.12.34 1.703.493.3.083.64.16.928.237l7.917 1.19c.64 0 1.235.045 1.869.045l8.96 1.53s-.045-.077-.122-.231l-.582-1.088-24.954-7.11"
      />
      <rect
        width="1.19"
        height="1.069"
        x="18.509"
        y="133.434"
        fill="#EF795C"
        rx=".467"
      />
      <rect
        width="1.402"
        height="1.254"
        x="17.894"
        y="131.194"
        fill="#EF795C"
        rx=".55"
      />
      <rect
        width="1.766"
        height="1.587"
        x="17.6"
        y="128.544"
        fill="#EF795C"
        rx=".691"
      />
      <rect
        width="1.44"
        height="1.6"
        x="79.794"
        y="135.36"
        fill="#D1445C"
        rx=".627"
        transform="rotate(-74.5 80.514 136.16)"
      />
      <path
        fill="#D1445C"
        d="M81.517 133.594l.3.038c.15.019.285.098.374.219.09.12.126.273.1.421v.16c-.046.307-.332.52-.64.474l-.294-.045c-.15-.019-.284-.098-.374-.219-.09-.12-.125-.273-.1-.421v-.154c.02-.148.097-.282.217-.37.12-.09.27-.127.417-.103z"
      />
      <rect
        width="1.587"
        height="1.766"
        x="81.768"
        y="130.575"
        fill="#D1445C"
        rx=".691"
        transform="rotate(-82.57 82.562 131.458)"
      />
      <path
        fill="#1B1934"
        d="M77.491 99.917c-1.728-1.498-.845-2.97-.281-4.73.352-1.03-2.772-3.513-3.015-3.904-.243-.39 1.14-2.246.141-3.526-.528-.594-.997-1.237-1.402-1.92-.083-.314-2.003-2.701-2.502-2.413-1.51.883-2.522 1.523-4.32 1.83-2.41.423-4.841.71-7.283.858-1.095-.09-3.091-.07-5.018-.051-1.632 0-3.2.038-4.173 0h-.102c-2.112-.173-4.211-.18-6.317-.525-1.107-.198-5.017-.82-5.638-.883-.352 0-.531 1.709-.378 2.233.064.64 7.2 2.67 8.352 3.31.973.863-7.949-.954-8.608-1.108-.761 0-1.216.166-1.587 1.837-.371 1.67 1.92 1.408 1.67 2.56-.25 1.152-3.2 1.657-4.179 1.785-.187.02-.376.02-.563 0-.266-.04-.538-.01-.787.09-.269.147-1.453 3.13-2.464 4.826 9.881 1.126 29.497 2.873 48.454-.314"
      />
      <path
        fill="#454560"
        d="M30.214 81.78s-2.56-.033-1.33 2.194c0 0-3.322-.275-1.614 3.284l1.984-.756.48-1.606.48-3.117z"
      />
      <path
        fill="#1B1934"
        d="M30.81 85.382c-.583-.384-1.108-.85-1.677-1.28v.039c-.928-.743-.999.697-.999.697l3.117 1.575c-.213-.312-.363-.662-.441-1.03z"
      />
      <path
        fill="#850A14"
        d="M27.629 100.435L27.328 100.48 27.968 100.48 27.597 100.48"
      />
      <path
        fill="#3C3C56"
        d="M28.608 100.314c-.435.044-.762.09-.98.121h2.356l-1.376-.134"
      />
      <path
        fill="#17162F"
        d="M29.19 100.25L28.608 100.314 29.984 100.448 30.867 100.448 29.19 100.262"
      />
      <path
        fill="#17162F"
        d="M35.437 99.955c-2.663 0-4.826.154-6.247.295l1.677.185 11.443-.134c-2.283-.231-4.578-.347-6.873-.346"
      />
      <path
        fill="#ABAAB4"
        d="M64.55 27.482v0m-3.2-9.204c.712.692 1.3 1.502 1.735 2.394-.388-.844-.918-1.615-1.568-2.278l-.167-.116m-2.278-2.028c-.106.16-.221.314-.346.46.2.06.397.131.59.212l-.244-.16v-.512m1.12-2.56c-.052.263-.118.524-.198.78.096-.251.162-.513.198-.78m1.536-.768l-1.114.556c.396-.132.77-.32 1.114-.556m1.715-3.079c-.245 1.04-.724 2.01-1.401 2.835.843-.707 1.352-1.735 1.401-2.835m-5.312-8.352c1.92.813 2.413 2.023 2.413 2.023s-.102-1.197-2.413-2.023"
      />
      <path
        fill="#363550"
        d="M58.7 16.71l-.095.11-3.482 2.022c.16.46.973.966 2.925 1.49 0 0 4.262.257 3.757 4.954 0 0-.493 3.38 2.086 3.38.215-.003.43-.025.64-.064v-1.12c-.057-2.345-.563-4.656-1.491-6.81-.436-.892-1.022-1.702-1.734-2.394l-2.036-1.356c-.192-.08-.389-.151-.588-.212"
      />
      <path
        fill="#363550"
        d="M60.16 13.664l-2.656 1.331c-1.102.591-2.333.901-3.584.903h-.109c.295.64.96 1.318 2.445 1.318.504-.004 1.007-.065 1.498-.18-1.12.327-2.925.986-2.637 1.806l3.481-2.023.096-.109c.125-.146.24-.3.346-.46v-.116c.367-.528.676-1.094.922-1.69.08-.256.146-.516.198-.78"
      />
      <path
        fill="#363550"
        d="M53.946.749s4.85 5.92-1.543 10.688c0 0-1.44 2.003 1.19 3.13-.034.455.043.912.225 1.33h.108c1.251 0 2.482-.31 3.584-.902l2.65-1.331v-.096c.139-.03.275-.07.41-.115l1.113-.557c.11-.075.214-.156.314-.243.677-.826 1.157-1.796 1.401-2.835.06-1.159-.126-2.317-.544-3.399l-1.28-1.817-1.1-1.114s-.48-1.21-2.413-2.022C56.715 1.032 55.314.79 53.9.749"
      />
      <path
        fill="#1B1934"
        d="M52.166 65.92c.128.038.48.87.57.998.462.724 1.078 1.336 1.805 1.792.888.53 1.954.674 2.95.397.698-.181 1.352-.503 1.92-.947.87-.698 1.338-1.498 2.56-1.453l5.018.87 3.251-3.084-9.3.147-5.76 1.42c-1.006.062-2.017.015-3.014-.14z"
      />
      <path
        fill="#8F90A0"
        d="M69.12 51.2c-.044 4.377-1.748 8.575-4.768 11.744-3.029 3.282-7.284 5.16-11.75 5.184-5.632 0-9.805-2.189-12.59-5.472-2.762-3.407-4.24-7.678-4.172-12.064h-.55c-.069 4.511 1.454 8.903 4.3 12.403 2.88 3.405 7.226 5.67 13.005 5.67 4.62-.024 9.023-1.964 12.16-5.356 3.097-3.276 4.841-7.601 4.883-12.109h-.518z"
      />
      <path
        fill="#D7854C"
        d="M6.4 95.578s.429 1.644 1.37 1.094l.819-.429s1.965-1.12.499-3.2L8.96 94.83l-.64.685-1.146.108-.774-.044z"
      />
      <path
        fill="#6B0810"
        d="M77.491 99.802h-.109l.11.096c-2.983.499-5.978.883-8.96 1.158l-2.126.3s-5.76 9.863-9.862 11.52c-.93.179-1.876.258-2.822.238-2.797 0-7.546-.557-13.703-3.38l1.28.839 12.16 6.643 23.04-15.02 1.223-.34c.712-.338 1.456-.604 2.22-.794l-2.496-1.28"
      />
      <path
        fill="#922F45"
        d="M37.51 108.5l3.84 2.08-1.28-.84c-.812-.37-1.65-.78-2.515-1.24M80 101.069c-.765.19-1.509.456-2.22.793l2.444-.678-.224-.115"
      />
      <path
        fill="#131127"
        d="M77.382 99.84l-8.844 1.28c2.976-.275 5.97-.64 8.96-1.158l-.11-.096"
      />
      <path
        fill="#1B1934"
        d="M73.19 76.723s-4.224 7.04-10.067 6.503c0 0-9.312-1.204-14.425 0 0 0-6.714 2.188-11.117 1.44l20.614 5.433 13.696-5.536-1.216-1.357s2.496-1.804 2.515-6.483zM42.304 101.242s10.957 5.478 28.493-.55l3.065-2.817-21.97-.467-9.588 3.834z"
      />
    </g>
  </svg>
);

export default BigWoman;
